import "@/App.css";
import Hero from "@/components/landing/Hero";
import SpotifySection from "@/components/landing/SpotifySection";
import Venue from "@/components/landing/Venue";
import Tables from "@/components/landing/Tables";
import Footer from "@/components/landing/Footer";
import StickyBar from "@/components/landing/StickyBar";

function App() {
  return (
    <div className="grain bg-night text-bone font-sans antialiased" data-testid="hugel-landing-page">
      <Hero />
      <SpotifySection />
      <Venue />
      <Tables />
      <Footer />
      <StickyBar />
    </div>
  );
}

export default App;
